<template>
  <v-container fluid id="return-create">
    <v-card outlined v-if="order && !loading">
      <v-container fluid>
        <v-row>
          <v-col md="12">
            <v-list-item>
              <v-list-item-content>
                <span class="text-uppercase" align="center">
                  {{ $t('return.returnOrderLabel') }} {{ order.order_id }}
                </span>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="isMobile" class="text-right">
              <v-list-item-content>
                <v-list-item-action-text class="text-uppercase" v-if="order.date">
                  {{ $t('return.date') }}:
                  {{ new Date(order.date) | moment('DD/MM/YYYY HH:mm:ss') }}
                </v-list-item-action-text>
                <v-list-item-action-text class="text-uppercase">
                  {{ $t('return.products') }}:
                  {{ getNbProducts() }}
                </v-list-item-action-text>
                <v-list-item-action-text class="text-uppercase">
                  {{ $t('return.amount') }}:
                  {{ order.total_price | formatPrice(order.currency) }}
                  {{ order.currency ? order.currency.code : order.currency_code }}
                </v-list-item-action-text>
                <v-list-item-action-text class="text-uppercase">
                  {{ $t('return.status') }}:
                  {{ getStatusTranslation(order.current_status) }}
                </v-list-item-action-text>
                <v-list-item-action-text v-if="order.sub_channel" class="text-uppercase">
                  {{ $t('order.subChannel') }}: {{ order.sub_channel }}
                </v-list-item-action-text>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-else class="text-right">
              <v-list-item-content>
                <v-list-item-title class="text-uppercase" v-if="order.date">
                  {{ $t('return.date') }}:
                  {{ new Date(order.date) | moment('DD/MM/YYYY HH:mm:ss') }}
                </v-list-item-title>
                <v-list-item-subtitle class="text-uppercase">
                  {{ $t('return.products') }}:
                  {{ getNbProducts() }}
                </v-list-item-subtitle>
                <v-list-item-subtitle class="text-uppercase">
                  {{ $t('return.amount') }}:
                  {{ order.total_price | formatPrice(order.currency) }}
                  {{ order.currency ? order.currency.code : order.currency_code }}
                </v-list-item-subtitle>
                <v-list-item-subtitle class="text-uppercase">
                  {{ $t('return.status') }}:
                  {{ getStatusTranslation(order.current_status) }}
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="order.sub_channel" class="text-uppercase">
                  {{ $t('order.subChannel') }}: {{ order.sub_channel }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-toolbar flat>
              <v-list-item-action-text v-if="isMobile">
                {{ $t('return.returnProductsMobile') }}:
              </v-list-item-action-text>
              <v-card-text v-else class="subtitle">{{ $t('return.returnProducts') }}:</v-card-text>
              <v-spacer></v-spacer>
              <v-btn outlined fab small right @click="openBarecodeDialog" class="mr-1">
                <v-icon>mdi-barcode</v-icon>
              </v-btn>
            </v-toolbar>
          </v-col>
        </v-row>
        <v-divider />
        <!-- list display mobile-->
        <product-list-mobile
          v-if="isMobile"
          :items="returnableItems"
          :currency="order.currency"
          :isReturnCreation="true"
          :displayItemCustomReturnReason="displayItemCustomReturnReason"
          :itemReturnReasons="itemReturnReasons"
          @addEventKeyDown="addEventKeyDown"
          @removeEventKeyDown="removeEventKeyDown"
        />
        <!-- list display -->
        <product-list
          v-else
          :items="returnableItems"
          :currency="order.currency"
          :isReturnCreation="true"
          :displayItemCustomReturnReason="displayItemCustomReturnReason"
          :itemReturnReasons="itemReturnReasons"
          @addEventKeyDown="addEventKeyDown"
          @removeEventKeyDown="removeEventKeyDown"
        />
        <v-divider />
        <v-container fluid>
          <v-row>
            <v-col class="d-flex justify-end">
              <v-switch
                v-if="homePickingActivated || isCustomerServiceOrAbove"
                v-model="productsReceived"
                :label="$t('return.productReceived')"
                @change="checkProductReceived"
              ></v-switch>
            </v-col>
          </v-row>
          <v-row v-if="!productsReceived && homePickingActivated">
            <v-col class="d-flex justify-end">
              <v-btn color="primary" depressed tile @click="updatePickingForm()">
                {{ $t('pickingForm.update') }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex justify-end">
              <v-simple-table dense id="summary-table">
                <tbody>
                  <tr>
                    <td class="mid-row"></td>
                    <td class="mid-row text-right pl-0 pr-1">
                      <v-list-item-action-text v-if="isMobile">
                        {{ $t('return.productsTotal') }}:
                      </v-list-item-action-text>
                      <span v-else>{{ $t('return.productsTotal') }}:</span>
                      :
                    </td>
                    <td class="mid-row text-right pl-0">
                      <v-list-item-action-text v-if="isMobile">
                        {{ totalSelectItemsAmount.toFixed(2) }}
                        {{ order.currency ? order.currency.code : order.currency_code }}
                      </v-list-item-action-text>
                      <span v-else>
                        {{ totalSelectItemsAmount.toFixed(2) }}
                        {{ order.currency ? order.currency.code : order.currency_code }}
                      </span>
                    </td>
                  </tr>
                  <tr v-if="refundTransport">
                    <td :class="returnFeesAmount ? 'mid-row text-right' : 'text-right'">
                      <v-icon x-small>mdi-plus</v-icon>
                    </td>
                    <td :class="returnFeesAmount ? 'mid-row text-right pl-0 pr-1' : 'text-right pl-0 pr-1'">
                      <v-list-item-action-text v-if="isMobile">
                        {{ $t('return.transportCosts') }}:
                      </v-list-item-action-text>
                      <span v-else>{{ $t('return.transportCosts') }}:</span>
                    </td>
                    <td :class="returnFeesAmount ? 'mid-row text-right pl-0' : 'text-right pl-0'">
                      <v-list-item-action-text v-if="isMobile">
                        {{ order.carrier.cost.toFixed(2) }}
                        {{ order.currency ? order.currency.code : order.currency_code }}
                      </v-list-item-action-text>
                      <span v-else>
                        {{ order.carrier.cost.toFixed(2) }}
                        {{ order.currency ? order.currency.code : order.currency_code }}
                      </span>
                    </td>
                  </tr>
                  <tr v-if="returnFeesAmount">
                    <td class="text-right"><v-icon x-small>mdi-minus</v-icon></td>
                    <td class="text-right pl-0 pr-1">
                      <v-list-item-action-text v-if="isMobile">{{ $t('return.returnFees') }}:</v-list-item-action-text>
                      <span v-else>{{ $t('return.returnFees') }}:</span>
                    </td>
                    <td class="text-right pl-0">
                      <v-list-item-action-text v-if="isMobile">
                        {{ returnFeesAmount.toFixed(2) }} {{ returnFeesAmountCurrency.code }}
                      </v-list-item-action-text>
                      <span v-else>{{ returnFeesAmount.toFixed(2) }} {{ returnFeesAmountCurrency.code }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-right"></td>
                    <td class="text-right pl-0 pr-1">
                      <v-list-item-action-text v-if="isMobile">
                        {{ $t('return.refundAmount') }}:
                      </v-list-item-action-text>
                      <span v-else>{{ $t('return.refundAmount') }}:</span>
                    </td>
                    <td class="text-right pl-0">
                      <v-list-item-action-text v-if="isMobile">
                        {{ refund.toFixed(2) }} {{ order.currency ? order.currency.code : order.currency_code }}
                      </v-list-item-action-text>
                      <span v-else>
                        {{ refund.toFixed(2) }} {{ order.currency ? order.currency.code : order.currency_code }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-container>
        <v-row justify="center">
          <v-col class="text-center">
            <v-btn
              color="primary"
              :loading="loading"
              :large="!isMobile"
              :medium="isMobile"
              depressed
              tile
              @click="openConfirmationDialog"
              :disabled="selectedItems.length == 0 || missingReason"
            >
              {{ $t('return.validate') }}
            </v-btn>
          </v-col>
        </v-row>
        <confirmation-create-return
          v-model="showConfirmationDialog"
          @validate="createReturn"
          @close="closeConfirmationDialog"
        ></confirmation-create-return>
      </v-container>
    </v-card>
    <!-- modals -->
    <barecode-type-dialog
      :title="$t('product.enterYourBarcode')"
      v-model="showBarecodeDialog"
      @validate="validateBarecodeDialog"
      @close="addEventKeyDown"
    />
    <PickingReturnFormDialog
      v-if="order && returnSettings"
      :pickingAddress="pickingAddress"
      :shippingAddress="order.shipping_address"
      :carrierType="order.carrier.carrier_type"
      :dialogText="updatePickingAddress ? $t('pickingForm.updatePickingAddressText') : $t('pickingForm.setUpPicking')"
      v-model="formPickingDialog"
      :settings="returnSettings"
      @close="close()"
      @validateForm="validateForm"
    />
    <spread-item-scan-dialog
      v-model="spreadItemScanDialog"
      :title="$t('product.customVariant')"
      :introductionSentence="$t('product.customReturnVariantText')"
    ></spread-item-scan-dialog>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import ConfirmationCreateReturn from '../../components/dialogs/ConfirmationCreateReturn'
  import SimpleTextInputDialog from '@/components/dialogs/SimpleTextInputDialog'
  import informationDialog from '@/components/dialogs/InformationDialog'
  import { EventBus } from '../../event-bus'
  import PickingReturnFormDialog from '@/components/dialogs/PickingReturnFormDialog'
  import ProductListMobile from '@/components/returns/products/ProductListMobile.vue'
  import ProductList from '@/components/returns/products/ProductList.vue'

  export default {
    name: 'ReturnCreate',
    props: {
      id: {
        type: String,
        default: undefined,
      },
    },
    components: {
      ConfirmationCreateReturn,
      barecodeTypeDialog: SimpleTextInputDialog,
      PickingReturnFormDialog,
      ProductList,
      ProductListMobile,
      spreadItemScanDialog: informationDialog,
    },
    data() {
      return {
        order: null,
        scan: '',
        showBarecodeDialog: false,
        showConfirmationDialog: false,
        defaultImage: require('@/assets/img/products/product_default.png'),
        loading: false,
        productsReceived: true,
        formPickingDialog: false,
        requestedPickingDate: null,
        pickingAddress: null,
        updatePickingAddress: false,
        returnSettings: null,
        charge_return_fees: null,
        status: [
          { text: this.$t('return.delivered'), value: 'delivered' },
          { text: this.$t('return.deliveredPartially'), value: 'partially_delivered' },
        ],
        spreadItemScanDialog: false,
        homePickingActivated: false,
        displayItemCustomReturnReason: true,
        itemReturnReasons: [],
      }
    },
    mounted() {
      if (this.id) {
        this.getTransaction()
        this.addEventKeyDown()
      }
      if (this.isCustomerServiceOrAbove) {
        this.productsReceived = false
      }
    },
    beforeDestroy() {
      this.removeEventKeyDown()
    },
    methods: {
      getNbProducts() {
        // get number of items
        let nbProduct = 0
        for (let item of this.order.items) {
          nbProduct += item.validated_quantity
        }
        return nbProduct
      },
      openBarecodeDialog() {
        //open barcode dialog to manually insert barcode
        this.removeEventKeyDown()
        this.showBarecodeDialog = true
      },
      validateBarecodeDialog: function (ean) {
        this.addEventKeyDown()
        this.checkItemsForScan(ean)
      },
      checkItemsForScan(value) {
        // check items if product_ean equals to ean scan
        for (let item of this.returnableItems) {
          let barcode = item.product_ean || item.barcode
          if (barcode == value) {
            if (this.getItemOccurrences(barcode) > 1) {
              this.spreadItemScanDialog = true
              return
            }
            if (item.is_returnable === false) {
              EventBus.$emit('displaySnackbar', {
                display: true,
                text: this.$t('return.productNotReturnable'),
                color: 'error',
              })
              return
            } else if (item.return_quantity < item.validated_quantity) {
              item.return_quantity++
              EventBus.$emit('displaySnackbar', {
                display: true,
                text: this.$t('product.productScanned'),
                color: 'success',
              })
              this.showBarecodeDialog = false
              return
            } else {
              EventBus.$emit('displaySnackbar', {
                display: true,
                text: this.$t('product.productAlreadyScanned'),
                color: 'error',
              })
              return
            }
          }
        }
        EventBus.$emit('displaySnackbar', {
          display: true,
          text: this.$t('product.productScannedError'),
          color: 'error',
        })
      },
      addEventKeyDown() {
        // add event to scan a product
        document.addEventListener('keydown', this.convertSpecialCharToNumber)
      },
      removeEventKeyDown() {
        // remove the event
        document.removeEventListener('keydown', this.convertSpecialCharToNumber)
      },
      convertSpecialCharToNumber(event) {
        // convert the caracters got from scan and store it to scan data then compare ean
        let charCode = event.charCode ? event.charCode : event.keyCode
        if (charCode >= 48 && charCode <= 57) {
          this.scan += String.fromCharCode(charCode)
        } else if (charCode == 13 && this.scan.trim() != '') {
          this.checkItemsForScan(this.scan)
          this.scan = ''
        }
      },
      convertPrice(value, currency) {
        const priceMultiplier = currency ? Math.pow(10, currency.minor_unit) : 100
        return value / priceMultiplier
      },
      createReturn() {
        // create return with itemselected data
        this.loading = true
        this.showConfirmationDialog = false
        let refundReturn = this.refund
        let currency = this.order.currency ? this.order.currency.code : this.order.currency_code
        let currentStatus = this.productsReceived ? 'products_received' : 'waiting_products_receipt'
        const priceMultiplier = this.returnFeesAmountCurrency?.currency_code
          ? Math.pow(10, this.returnFeesAmountCurrency?.currency_code)
          : 100
        let returnOrder = {
          order_id: this.order.order_id,
          date: new Date(),
          currency_code: currency,
          current_status: currentStatus,
          amount: refundReturn,
          status_history: [
            {
              label_status: currentStatus,
              date: new Date(),
              status_comment: '',
            },
          ],
          items: this.selectedItems,
          customer: this.order.customer,
          shipping_address: this.order.shipping_address,
          billing_address: this.order.billing_address,
          origin_location_id: this.isInStoreCreation ? this.currentStore : undefined,
          transport_refund_amount: this.refundTransport ? this.order.carrier.cost : undefined,
          return_fees_amount: this.returnFeesAmount ? this.returnFeesAmount * priceMultiplier : undefined,
        }
        if (this.pickingAddress && this.requestedPickingDate) {
          returnOrder.picking_address = this.pickingAddress
          returnOrder.requested_picking_date = this.requestedPickingDate
          returnOrder.charge_return_fees = this.charge_return_fees
        }

        //TODO a revoir car petit soucis au niveau de la conversion
        let myInit = {
          headers: {
            Authorization: 'Bearer ' + this.$auth.accessToken,
          },
          body: returnOrder,
        }
        this.$Amplify.API.post('returns', '/v1/int/returns', myInit)
          .then((res) => {
            this.loading = false
            if (this.isInStoreCreation) {
              this.$router.push('/returns/' + res.return_id)
            } else {
              this.$router.push('/returns')
            }

            EventBus.$emit('displaySnackbar', {
              display: true,
              text: this.$t('return.returnCreated'),
              color: 'success',
            })
          })
          .catch((e) => {
            this.loading = false
            EventBus.$emit('displaySnackbar', {
              display: true,
              text: e.message,
              color: 'error',
            })
          })
      },
      openConfirmationDialog() {
        // open confirmation dialog for validate
        this.removeEventKeyDown()
        this.showConfirmationDialog = true
      },
      closeConfirmationDialog() {
        this.addEventKeyDown()
        this.showConfirmationDialog = false
      },
      getTransaction() {
        this.loading = true
        // get the order
        let path = '/v1/int/transactions/' + this.id
        let myInit = {
          headers: {
            Authorization: 'Bearer ' + this.$auth.accessToken,
          },
        }
        this.$Amplify.API.get('returns', path, myInit)
          .then((res) => {
            for (let item of res.order.items) {
              item.return_reason = undefined
              item.custom_return_reason = undefined
              item.product_sale_price = this.convertPrice(item.product_sale_price, res.order.currency)
              if (item.product_default_price) {
                item.product_default_price = this.convertPrice(item.product_default_price, res.order.currency)
              }
              if (item.product_sale_price_exclude_tax) {
                item.product_sale_price_exclude_tax = this.convertPrice(
                  item.product_sale_price_exclude_tax,
                  res.order.currency
                )
              }
              if (item.returned_quantity > 0) {
                item.validated_quantity = item.validated_quantity - item.returned_quantity
                item.returned_quantity = undefined
              }
              item.return_quantity = 0
            }
            if (res.order.carrier && res.order.carrier.cost) {
              res.order.carrier.cost = this.convertPrice(res.order.carrier.cost, res.order.currency)
            } else {
              res.order.carrier = {}
              res.order.carrier.cost = this.convertPrice(0, res.order.currency)
            }
            this.order = res.order
            this.getReturnSettings(this.order.shipping_address.country_code)
          })
          .catch((e) => {
            this.loading = false
            EventBus.$emit('displaySnackbar', {
              display: true,
              color: 'error',
              //todo fix trad
              text: 'error during order loading',
            })
            console.log(e)
          })
      },
      checkProductReceived(newValue) {
        if (this.homePickingActivated) {
          if (!newValue) {
            this.formPickingDialog = true
          } else if (newValue && this.pickingAddress) {
            this.pickingAddress = null
            this.requestedPickingDate = null
          }
        }
      },
      close() {
        this.formPickingDialog = false
      },
      validateForm(values) {
        this.pickingAddress = values
        this.charge_return_fees = values.charge_return_fees
        this.requestedPickingDate = values.requested_picking_date
      },
      updatePickingForm() {
        this.formPickingDialog = true
        this.updatePickingAddress = true
      },
      getReturnSettings(countryCode) {
        let myInit = {
          headers: {
            Authorization: 'Bearer ' + this.$auth.accessToken,
          },
          queryStringParameters: {
            filters: JSON.stringify({
              countries: [countryCode],
              default_settings: true,
            }),
          },
        }
        this.$Amplify.API.get('returns', '/v1/int/settings', myInit)
          .then((res) => {
            let returnSettings = res.data.find((item) => item.country_code === countryCode)
            if (!returnSettings) {
              returnSettings = res.data.find((item) => item.default_settings === true)
            }
            this.returnSettings = returnSettings
            this.displayItemCustomReturnReason = returnSettings?.display?.item_custom_return_reason !== false
            this.homePickingActivated = this.returnSettings && this.returnSettings.available_address_picking
            this.itemReturnReasons = this.returnSettings?.display?.item_return_reasons
            this.loading = false
          })
          .catch((e) => {
            this.loading = false
            console.error(e)
          })
      },
      getStatusTranslation: function (statusValue) {
        let status = this.status.find((status) => status.value == statusValue)
        if (status) {
          return status.text
        } else return statusValue
      },
      getItemOccurrences(barcode) {
        return this.returnableItems.reduce((accumulator, currentValue) => {
          if (barcode == currentValue.barcode) {
            return accumulator + 1
          } else {
            return accumulator
          }
        }, 0)
      },
    },
    computed: {
      refund() {
        //update the refund
        let refund = this.totalSelectItemsAmount

        if (this.refundTransport) {
          refund += this.order.carrier.cost
        }
        refund -= this.returnFeesAmount
        return refund > 0 ? refund : 0
      },
      ...mapState(['roles', 'currentStore']),
      returnableItems() {
        return this.order.items.filter((item) => item.validated_quantity > 0 && item.current_status != 'cancelled')
      },
      selectedItems() {
        return this.returnableItems.filter((item) => item.return_quantity > 0)
      },
      missingReason() {
        for (let item of this.selectedItems) {
          if (item.return_reason == undefined) {
            return true
          }
        }
        return false
      },
      isInStoreCreation() {
        return this.roles && (this.roles.includes('oms-shop-manager') || this.roles.includes('default-user'))
      },
      isCustomerServiceOrAbove() {
        return (
          this.roles &&
          (this.roles.includes('oms-customer-service') ||
            this.roles.includes('oms-admin') ||
            this.roles.includes('octipas-admin'))
        )
      },
      refundTransport() {
        if (!this.returnSettings?.refund_order_carrier_cost?.activate || this.order?.carrier?.refund_return_id) {
          return false
        }
        let totalStillReturnableValidatedQuantity = 0
        for (let item of this.order.items) {
          if (item.is_returnable !== false) {
            totalStillReturnableValidatedQuantity += item.validated_quantity
          }
          //TODO check if we shouldn't use product_id to find item instead of ean
          let selectedItemForCurrentReturn = this.selectedItems.find(
            (selectedItem) => selectedItem.product_id == item.product_id || selectedItem.product_ean == item.product_ean
          )
          if (selectedItemForCurrentReturn) {
            totalStillReturnableValidatedQuantity -= selectedItemForCurrentReturn.return_quantity
          }
        }
        return totalStillReturnableValidatedQuantity <= 0
      },
      isMobile() {
        return this.$vuetify.breakpoint.width < 650
      },
      chargeReturnFees() {
        return (
          this.returnSettings?.charge_return_fees?.available &&
          this.returnSettings.charge_return_fees.prepaid_return_label
        )
      },
      returnFeesAmount() {
        return this.chargeReturnFees ? this.returnSettings.charge_return_fees.return_fees_amount : 0
      },
      returnFeesAmountCurrency() {
        return this.chargeReturnFees ? this.returnSettings.charge_return_fees.return_fees_currency : {}
      },
      totalSelectItemsAmount() {
        let refund = 0
        for (let item of this.selectedItems) {
          refund += item.product_sale_price * item.return_quantity
        }
        return refund
      },
    },
  }
</script>

<style scoped>
  .mid-row {
    border-bottom: none !important;
  }
  #summary-table tr:hover:not(.v-table__expanded__content) {
    background: transparent !important;
  }
</style>
